var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 340.745,
    height: 358.708,
    viewBox: "0 0 340.745 358.708",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -18.882,
    y1: 0.123,
    x2: 19.882,
    y2: 0.877,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.024,
    stopColor: "#090400",
    stopOpacity: 0.047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166,
    stopColor: "#3f1d00",
    stopOpacity: 0.298
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309,
    stopColor: "#6d3200",
    stopOpacity: 0.514
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451,
    stopColor: "#924300",
    stopOpacity: 0.686
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592,
    stopColor: "#af5000",
    stopOpacity: 0.824
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    stopColor: "#c45a00",
    stopOpacity: 0.922
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.868,
    stopColor: "#d06000",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d56200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -18.944,
    y1: 0.123,
    x2: 19.944,
    y2: 0.877,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.135,
    stopColor: "#00c795",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.275,
    stopColor: "#00bb8c",
    stopOpacity: 0.918
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    stopColor: "#00a67c",
    stopOpacity: 0.816
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561,
    stopColor: "#008967",
    stopOpacity: 0.675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707,
    stopColor: "#00644b",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.853,
    stopColor: "#003628",
    stopOpacity: 0.267
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopOpacity: 0.004
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.064,
    y1: 0.5,
    x2: 0.936,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.002,
    stopOpacity: 0.004
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.147,
    stopColor: "#1b0d36",
    stopOpacity: 0.267
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293,
    stopColor: "#321964",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.439,
    stopColor: "#442289",
    stopOpacity: 0.675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582,
    stopColor: "#5329a6",
    stopOpacity: 0.816
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.725,
    stopColor: "#5d2ebb",
    stopOpacity: 0.918
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#6331c7",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0.282,
    y1: 34.174,
    x2: 0.718,
    y2: -33.174,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1779b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.145,
    stopColor: "#1676ad",
    stopOpacity: 0.976
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    stopColor: "#146da1",
    stopOpacity: 0.906
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#125f8c",
    stopOpacity: 0.788
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.602,
    stopColor: "#0e4b6f",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopColor: "#09324a",
    stopOpacity: 0.416
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913,
    stopColor: "#03131c",
    stopOpacity: 0.161
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2801.91 -3941.49)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M2972.282 4120.844l32.755-18.911m-65.51 0l32.755 18.911"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2817.957 4031.745v178.2l154.325 89.1 154.325-89.1v-178.2l-154.325-89.1z",
    fill: "none",
    stroke: "#d5d7db",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2823.091 4034.708v172.272l149.191 86.135 149.191-86.135v-172.272l-149.191-86.136z",
    fill: "none",
    stroke: "#d5d7db",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2828.225 4037.672v166.343l144.058 83.172 144.058-83.172v-166.343l-144.059-83.172z",
    fill: "none",
    stroke: "#d5d7db",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2833.358 4040.636v160.415l138.924 80.208 138.924-80.208v-160.415l-138.924-80.208z",
    fill: "none",
    stroke: "#d5d7db",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2838.492 4043.6v154.488l133.79 77.244 133.79-77.244V4043.6l-133.79-77.244z",
    fill: "none",
    stroke: "#d5d7db",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2843.626 4046.564v148.56l128.656 74.28 128.657-74.28v-148.56l-128.657-74.28z",
    fill: "none",
    stroke: "#d5d7db",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2848.76 4049.528v142.632l123.523 71.316 123.523-71.316v-142.632l-123.523-71.316z",
    fill: "none",
    stroke: "#d5d7db",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2853.893 4052.492v136.7l118.389 68.352 118.389-68.352v-136.7l-118.389-68.352z",
    fill: "none",
    stroke: "#d5d7db",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2859.027 4055.456v130.776l113.255 65.388 113.256-65.388v-130.776l-113.256-65.388z",
    fill: "none",
    stroke: "#d5d7db",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2864.161 4058.42v124.848l108.122 62.424 108.122-62.424V4058.42L2972.282 3996z",
    fill: "none",
    stroke: "#d5d7db",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2869.294 4061.384V4180.3l102.988 59.46 102.988-59.46v-118.92l-102.988-59.46z",
    fill: "none",
    stroke: "#d5d7db",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2874.428 4064.348v112.992l97.854 56.5 97.854-56.5v-112.992l-97.854-56.5z",
    fill: "none",
    stroke: "#d5d7db",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2879.562 4067.312v107.065l92.721 53.532 92.717-53.533v-107.064l-92.721-53.532z",
    fill: "none",
    stroke: "#d5d7db",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2884.7 4070.276v101.137l87.587 50.568 87.587-50.568v-101.137l-87.587-50.568z",
    fill: "none",
    stroke: "#d5d7db",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2889.829 4073.24v95.209l82.453 47.6 82.453-47.6v-95.209l-82.453-47.6z",
    fill: "none",
    stroke: "#d5d7db",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2894.963 4076.2v89.281l77.32 44.64 77.32-44.64V4076.2l-77.32-44.64z",
    fill: "none",
    stroke: "#d5d7db",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2900.1 4079.168v83.353l72.186 41.677 72.186-41.677v-83.353l-72.186-41.677z",
    fill: "none",
    stroke: "#d5d7db",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2905.23 4082.132v77.425l67.052 38.713 67.052-38.713v-77.425l-67.052-38.713z",
    fill: "none",
    stroke: "#d5d7db",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2910.364 4085.1v71.5l61.918 35.749 61.919-35.749v-71.5l-61.919-35.749z",
    fill: "none",
    stroke: "#d5d7db",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2915.5 4088.059v65.57l56.785 32.785 56.785-32.785v-65.57l-56.785-32.785z",
    fill: "none",
    stroke: "#d5d7db",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-60 5055.644 -512.926)",
    fill: "url(#a)",
    d: "M0 0h2v177.914H0z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-60 4901.184 -423.631)",
    fill: "url(#b)",
    d: "M0 0h2v178.485H0z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-30 9173.765 -3485.481)",
    fill: "url(#c)",
    d: "M0 0h177.914v2H0z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-30 9262.99 -3152.425)",
    fill: "url(#d)",
    d: "M0 0h178.485v2H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.048,
    cy: 16.048,
    r: 16.048,
    transform: "translate(2801.91 4193.896)",
    fill: "#1779b2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.038,
    cy: 8.038,
    r: 8.038,
    transform: "translate(2809.92 4201.906)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.048,
    cy: 16.048,
    r: 16.048,
    transform: "translate(3110.56 4192.767)",
    fill: "#d56200"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.038,
    cy: 8.038,
    r: 8.038,
    transform: "translate(3118.57 4200.777)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.048,
    cy: 16.048,
    r: 16.048,
    transform: "translate(3110.56 4015.697)",
    fill: "#63c"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.038,
    cy: 8.038,
    r: 8.038,
    transform: "translate(3118.57 4023.707)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.16,
    cy: 29.16,
    r: 29.16,
    transform: "translate(2943.122 4091.684)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.048,
    cy: 16.048,
    r: 16.048,
    transform: "translate(2801.91 4015.697)",
    fill: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.038,
    cy: 8.038,
    r: 8.038,
    transform: "translate(2809.92 4023.707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3009.287 4099.481v42.724l-37.008 21.362v-42.724z",
    fill: "#333",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3009.287 4099.481l-37.008 21.362-37-21.362 37-21.362z",
    fill: "#272727",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2972.279 4120.843v42.724l-37-21.362v-42.724z",
    fill: "#404040",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2939.53 4101.933l32.75 18.91 32.76-18.91",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.ebff110b5eaf6232884d4f08738e81c8.svg";
export { ForwardRef as ReactComponent };